import ct from "class-types.macro";
import React from "react";
import { Image } from "@clarkinc/zest-design-system/ui";
import { User } from "~/common/Store/models/User";
import Pagination from "../../../Pagination";
import ProductReview from "../ProductReview";
import { MediaIdentifier, ProductReviewDetail } from "../../reviewModels";
import warehouseLocation from "~/common/Store/models/warehouseLocation";
interface Props {
  productReviewDetails: ProductReviewDetail[];
  user: User;
  handleSelectMediaElement: (newMedia: MediaIdentifier | undefined) => void;
  addUserUpvote: (reviewId: number, upvoted: boolean) => void;
  currentReviewUpvotes: Readonly<Record<number, boolean>>;
  usePagination: boolean;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  filterByRatingEnabled: boolean | undefined;
}
const TextReviewsSection = ({
  addUserUpvote,
  currentReviewUpvotes,
  handleSelectMediaElement,
  productReviewDetails,
  usePagination,
  user,
  currentPage,
  setCurrentPage,
  filterByRatingEnabled
}: Props) => {
  const pageSize = 40;
  const numberOfReviews = productReviewDetails.length;
  const showPagination = numberOfReviews > pageSize;
  return <>
      {numberOfReviews > 0 ? productReviewDetails.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((productReviewDetail, index) => <ProductReview review={productReviewDetail} reviewLocation={warehouseLocation.LeolaCDC2} user={user} key={productReviewDetail.reviewId} productReviewIndex={index} handleSelectMediaElement={handleSelectMediaElement} addUserUpvote={addUserUpvote} userUpvoted={!!currentReviewUpvotes[productReviewDetail.reviewId]} userVoted={currentReviewUpvotes[productReviewDetail.reviewId] !== undefined} verifiedPurchase={productReviewDetail.isVerifiedPurchase} />) : <>
          {filterByRatingEnabled ? <div className="flex flex-col justify-center items-center py-10 my-4 bg-white border border-solid border-gray-200 xs:rounded">
              <Image src={"/uploads/design/2024/9/text-review-icon.svg"} alt="" height={112} width={112} />
              <p className="text-xl leading-[25px] font-semibold text-gray-900 text-center pt-4">
                No reviews match the current
                <br /> filter criteria.
              </p>
            </div> : <span>No reviews match the current filter criteria.</span>}
        </>}
      {usePagination && showPagination && <div data-testid="product-review-pagination" id="paging" className={ct("clear-both", "p-6", "text-center")}>
          <Pagination onChange={page => setCurrentPage(page)} currentPage={currentPage} total={productReviewDetails.length} pageSize={pageSize} />
        </div>}
    </>;
};
export default TextReviewsSection;